import React, { useCallback, useEffect, useState } from "react";

import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  CircularProgress,
  Grid2,
  Grid,
  Typography,
} from "@mui/material";
import { connect } from "react-redux";
import CREATEASSESSMENTIMG from "../../assets/images/createassessment.png";

// import AssessmentDetailsModal from "./AssessmentDetailModal";
import AssessmentsCards from "./AssessmentsCards";
import { getRecentlyAddedAssessments as getRecentlyAddedAssessmentsAction } from "../../redux/slices/assessmentsSlice";
import { useNavigate } from "react-router-dom";

const RecentlyCreatedAssessments = ({
  isUserCompanySetup,
  recentlyAddedAssessments,
  getRecentlyAddedAssessments,
  handleAssessmentSelect,
  searchQuery,
  selectedFilters,
  handleOpenModal,
  isModal,
  selectedAssessmentId,
  recentlyAddedAssessmentsCount,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const isFilterApplied = Object.values(selectedFilters || {})?.flat()?.length;
  const navigate = useNavigate();

  useEffect(() => {
    if (isUserCompanySetup || !searchQuery || !isFilterApplied) {
      _getData(4, true);
    }
  }, []);
  console.log(selectedFilters);

  const _getData = useCallback(async (take = 4, hideLoader) => {
    if (!hideLoader) {
      setIsLoading(true);
    }

    await getRecentlyAddedAssessments({
      page: 1,
      take,
    });

    setIsLoading(false);
  }, []);

  if (!isUserCompanySetup || searchQuery || isFilterApplied) {
    return (
      <Box height="100%">
        <Typography fontSize="26px" fontWeight={500} p={2}>
          Overall Assessments
        </Typography>
      </Box>
    );
  }

  return (
    <Box height="100%">
      {recentlyAddedAssessments?.length > 0 && (
        <Typography fontSize="26px" fontWeight={500} p={2}>
          Recently Created
        </Typography>
      )}
      {isLoading ? (
        <Box
          height="200px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3} sx={{ px: 2 }}>
          {recentlyAddedAssessments?.map((id, index) => (
            <Grid key={id} item size={{ xs: 12, sm: 8, md: 6 }}>
              <AssessmentsCards
                index={index}
                id={id}
                handleAssessmentSelect={handleAssessmentSelect}
                handleOpenModal={handleOpenModal}
                isModal={isModal}
                selectedAssessmentId={selectedAssessmentId}
              />
            </Grid>
          ))}

          {recentlyAddedAssessments?.length % 2 === 1 && (
            <Grid item size={{ xs: 12, sm: 8, md: 6 }}>
              <ButtonBase
                onClick={() => navigate("create")}
                sx={{
                  width: "100%",
                  border: 2,
                  borderRadius: "5px",
                  borderColor: "#d1d1d1",
                  backgroundImage: `url(${CREATEASSESSMENTIMG})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "370px",
                }}
              />
            </Grid>
          )}
        </Grid>
      )}
      {recentlyAddedAssessments?.length < recentlyAddedAssessmentsCount && (
        <Box className="center" mt={1}>
          <ButtonBase
            sx={{ p: 1.5, color: "#4BC7E1", fontWeight: 600 }}
            onClick={() => _getData(10000000)}
          >
            Load more assessment <KeyboardDoubleArrowDown />
          </ButtonBase>
        </Box>
      )}

      <Typography fontSize="26px" fontWeight={500} p={2}>
        Overall Assessments
      </Typography>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  isUserCompanySetup: state.auth?.user?.company_id,
  recentlyAddedAssessments: state.assessments.recentlyAddedAssessments,
  recentlyAddedAssessmentsCount:
    state.assessments.recentlyAddedAssessmentsCount,
});

const mapDispatchToProps = {
  getRecentlyAddedAssessments: getRecentlyAddedAssessmentsAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentlyCreatedAssessments);
